<script lang="ts">
  import { useKeyboardListener } from '../../hooks'
  import { sceneMode } from '../../stores/scene-mode'

  $effect(() => {
    const tListener = useKeyboardListener('g', {
      onKeyPress: () => {
        $sceneMode = $sceneMode === 'translate' ? 'default' : 'translate'
      },
    })
    const rListener = useKeyboardListener('r', {
      onKeyPress: () => {
        $sceneMode = $sceneMode === 'rotate' ? 'default' : 'rotate'
      },
    })

    return () => {
      tListener()
      rListener()
    }
  })
</script>
